import { ranking } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            热搜榜单
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            实时热度排行，看看今天最火爆的爆料是什么
          </p>
        </div>

        <div className="max-w-[800px] mx-auto bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {ranking.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-3 md:gap-4 px-5 md:px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors group ${
                idx < ranking.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div
                className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-black text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                      ? 'bg-primary-400 text-white'
                      : item.rank === 3
                        ? 'bg-accent-400 text-white'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <h3 className="flex-1 font-semibold text-foreground-900 text-sm md:text-base leading-snug group-hover:text-primary-600 transition-colors min-w-0">
                {item.title}
              </h3>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400">{item.heat}</span>
                <span
                  className={`w-5 h-5 flex items-center justify-center ${
                    item.trend === 'up'
                      ? 'text-primary-500'
                      : item.trend === 'down'
                        ? 'text-foreground-400'
                        : 'text-accent-500'
                  }`}
                >
                  <i
                    className={`${
                      item.trend === 'up'
                        ? 'ri-arrow-up-line'
                        : item.trend === 'down'
                          ? 'ri-arrow-down-line'
                          : 'ri-add-line'
                    } w-4 h-4 flex items-center justify-center`}
                  ></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}